import {submit} from './../api';

const settlementClosing = {
  namespaced: true,
  state: {
    submitObj: null,
  },
  mutations: {
    SUBMIT(state, data) {
      state.submitObj = data;
    },
  },
  actions: {
    //关账提交
    async submit({ commit }, obj) {
      let resp = await submit(obj);
      commit('SUBMIT', resp);
    },
  }
}
export default settlementClosing



// WEBPACK FOOTER //
// ./src/page/settlementFee/settlementClosing/store/settlementClosing.store.js